import React from 'react'

import LockOutline from 'mdi-material-ui/ChartLine'
import AccountMultipleOutline from 'mdi-material-ui/AccountMultipleOutline'
import AccountOutline from 'mdi-material-ui/AccountOutline'
import FileDocumentOutline from 'mdi-material-ui/FileDocumentOutline'
import CalendarOutline from 'mdi-material-ui/CalendarOutline'
import CalendarImport from 'mdi-material-ui/CalendarToday'
import BullhornOutline from 'mdi-material-ui/BullhornOutline'
import LibraryOutline from 'mdi-material-ui/LibraryOutline'
import CogOutline from 'mdi-material-ui/CogOutline'
import CommentAlertOutline from 'mdi-material-ui/CommentAlertOutline'
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism'
import HomeOutline from '@mui/icons-material/HomeOutlined'
import WysiwygOutlined from '@mui/icons-material/WysiwygOutlined'
import CardMembershipOutlined from '@mui/icons-material/CardMembershipOutlined'

export const SideNavigationItems = [
  {
    title: 'Dashboard',
    icon: <HomeOutline />,
    path: '/dashboard',
    name: 'dashboard'
  },
  {
    title: 'Sub Admin',
    icon: <AccountOutline />,
    path: '/createsubadmin',
    name: 'Create SubAdmin'
  },
  {
    title: 'Announcement',
    icon: <BullhornOutline />,
    path: '/announcement',
    name: 'announcement'
  },
  {
    title: 'Library',
    icon: <LibraryOutline />,
    types: 'sub',
    name: 'library',
    subNav: [
      { title: 'Category Manage', path: '/library/category' },
      {
        title: 'Book Manage',
        path: '/library/book'
      }
    ]
  },
  {
    title: 'Program',
    icon: <FileDocumentOutline />,
    types: 'sub',
    name: 'program',
    subNav: [
      { title: 'Future Program', path: '/program/today' },
      {
        title: 'Archive List',
        path: '/archive/list',
      },
    ],
  },
  // {
  //   title: "Day's Adjustment",
  //   icon: <CalendarOutline />,
  //   path: '/daysadjustment',
  //   name: "day's_adjustment"
  // },

  {
    title: 'Team',
    icon: <AccountMultipleOutline />,
    path: '/team',
    name: 'team'
  },

  {
    title: 'Business',
    icon: <LockOutline />,
    types: 'sub',
    name: 'business',
    subNav: [
      { title: 'Category Manage', path: '/business/category' },
      {
        title: 'List',
        path: '/business/list'
      }
    ]
  },
  {
    title: 'User',
    icon: <AccountOutline />,
    path: '/user',
    name: 'user'
  },
  {
    title: 'Feedback',
    icon: <CommentAlertOutline />,
    types: 'sub',
    name: 'feedback',
    subNav: [
      { title: 'List', path: '/feedback/list' },
      {
        title: 'Type',
        path: '/feedback/type'
      }
    ]
  },
  {
    title: 'Donation',
    icon: <VolunteerActivismIcon />,
    types: 'sub',
    name: 'donation',
    subNav: [
      { title: 'Donation', path: '/donation/donation' },
      {
        title: 'Sadaqah',
        path: '/donation/sadaqah'
      },
      {
        title: 'Fitra',
        path: '/donation/fitra'
      }
    ]
  },
  {
    title: 'Donation Type',
    icon: <VolunteerActivismIcon />,
    path: '/donationtype',
    name: 'donation_type'
  },
  {
    title: 'General Settings',
    icon: <CogOutline />,
    path: '/generalsetting',

    name: 'general_setting'
  },
  {
    title: 'Calendar Settings',
    icon: <CalendarImport />,
    types: 'sub',
    name: 'calender_setting',
    subNav: [
      {
        title: 'Hijri Calendar',
        path: '/calendersetting/hijricalender'
      },
      {
        title: 'Special Days',
        path: '/calendersetting/specialdays'
      }
    ]
  },
  {
    title: 'Banner',
    icon: <WysiwygOutlined />,
    path: '/banner',
    name: 'banner'
  },
  {
    title: 'Memberships',
    icon: <CardMembershipOutlined />,
    types: 'sub',
    name: 'membership',
    subNav: [
      {
        title: 'Pricing',
        path: '/membership/pricing'
      },
      {
        title: 'Purchase List',
        path: '/membership/purchaselist'
      }
    ]
  }
]
